/**
 * Mount Stripe Payment Element without jumping the page scroll position.
 * Stripe's iframe receives focus on mount, which scrolls it into view.
 */
export function mountStripePaymentElement(paymentElement, selector) {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const previousActiveElement =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;

  const jumpThresholdPx = 80;
  const interactionWatchMs = 700;
  let userInteracted = false;

  const markUserInteracted = () => {
    userInteracted = true;
  };

  const maybeRestoreScroll = () => {
    if (userInteracted) {
      return;
    }
    const yDelta = Math.abs(window.scrollY - scrollY);
    const xDelta = Math.abs(window.scrollX - scrollX);
    if (yDelta >= jumpThresholdPx || xDelta >= jumpThresholdPx) {
      window.scrollTo({
        left: scrollX,
        top: scrollY,
        behavior: 'auto',
      });
    }
  };

  const scheduleGuardChecks = () => {
    requestAnimationFrame(maybeRestoreScroll);
    setTimeout(maybeRestoreScroll, 0);
    setTimeout(maybeRestoreScroll, 70);
    setTimeout(maybeRestoreScroll, 160);
    setTimeout(maybeRestoreScroll, 300);
  };

  window.addEventListener('wheel', markUserInteracted, {
    passive: true,
    capture: true,
  });
  window.addEventListener('touchmove', markUserInteracted, {
    passive: true,
    capture: true,
  });
  window.addEventListener('keydown', markUserInteracted, { capture: true });

  if (typeof paymentElement.on === 'function') {
    paymentElement.on('ready', () => {
      maybeRestoreScroll();
      requestAnimationFrame(maybeRestoreScroll);
    });
  }

  paymentElement.mount(selector);

  if (
    previousActiveElement &&
    typeof previousActiveElement.focus === 'function'
  ) {
    requestAnimationFrame(() => {
      try {
        previousActiveElement.focus({ preventScroll: true });
      } catch (error) {
        // Ignore browsers that do not support preventScroll options.
      }
    });
  }

  scheduleGuardChecks();
  setTimeout(() => {
    window.removeEventListener('wheel', markUserInteracted, true);
    window.removeEventListener('touchmove', markUserInteracted, true);
    window.removeEventListener('keydown', markUserInteracted, true);
  }, interactionWatchMs);
}
